import ExpireDaysCounter from "./ExpireDaysCounter";
import SaveForGoodMarketingElem from "../SaveForGood/SaveForGoodMarketingElem";
import { useContent } from "contexts/contentContext/contentContext";

import styles from "./expiresAfterElement.module.scss";
import { useUser } from "contexts/userContext/userContext";

const ExpiresAfterElement = ({
  isSettingItem,
}: {
  isSettingItem?: boolean;
}) => {
  const { getTextByKey } = useContent();
  const { isSubscribed } = useUser();

  return isSubscribed() && !isSettingItem ? null : (
    <div
      className={`${styles.container} ${
        isSettingItem ? styles.settingItem : ""
      }`}
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
      }}
    >
      {getTextByKey("expires-after")}{" "}
      {!isSubscribed() && isSettingItem ? (
        <SaveForGoodMarketingElem isSettingItem={isSettingItem} />
      ) : null}
      <ExpireDaysCounter isSettingItem={isSettingItem} />
      {!isSubscribed() && !isSettingItem ? <SaveForGoodMarketingElem /> : null}
    </div>
  );
};

export default ExpiresAfterElement;
